// Shared pill classes for the Advisors tab and the advisor students page; same look as ui.tsx Chip.
export const PILL =
  'inline-block whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold leading-4';
export const WARN_PILL = `${PILL} bg-state-warning-bg text-state-warning-text`;
export const SUCCESS_PILL = `${PILL} bg-state-success-bg text-state-success-text`;
// Bordered, not filled, so it stays visible on a hovered (sunken) row.
export const PLAIN_PILL = `${PILL} border border-line-subtle text-content-secondary`;
